<template>
  <div v-if="episodes">
    <Lamp></Lamp>

    <div class='text noMargin'>
      TETATET
    </div>
    <ul class='conversations'>
      <li v-for="issue in issues" v-if="navSwitch === 'issue'">
        <span class='text footerLink conversations_title' v-if="categoryCheck('issue', issue.title)">
          {{issue.title.toUpperCase()}}
        </span>
        <div 
          v-for="episode in episodes" 
          class='player'
          v-if="episode.issue === issue.title"
        > 
          <aplayer 
          :music="{
            title: episode.conversationist,
            author: ' ',
            url: episode.soundcloud,
            pic: ' '
          }"
          ></aplayer>
        </div>
      </li>

      <li v-for="loc in locations" v-if="navSwitch === 'location'">
        <span class='text footerLink conversations_title' v-if="categoryCheck('location', loc)">
          {{loc.toUpperCase()}}
        </span>
        <div 
          v-for="episode in episodes" 
          class='player'
          v-if="episode.location === loc"
        > 
          <aplayer 
          :music="{
            title: episode.conversationist,
            author: ' ',
            url: episode.soundcloud,
            pic: ' '
          }"></aplayer>
        </div>
      </li>

      <li v-for="category in categories" v-if="navSwitch === 'category'">
        <span class='text footerLink conversations_title' v-if="categoryCheck('category', category)">
          {{category.toUpperCase()}}
        </span>
        
        <div 
          v-for="episode in episodes" 
          class='player'
          v-if="episode.category === category"
        > 
          <aplayer 
          :music="{
            title: episode.conversationist,
            author: ' ',
            url: episode.soundcloud,
            pic: ' '
          }"></aplayer>
        </div>
      </li>

    </ul> 

    <ul class='sort'>
      <li v-on:click="nav('issue')" :class="{active: navSwitch === 'issue'}"><span>SORT<br>BY<br>ISSUE</span></li>
      <li v-on:click="nav('location')" :class="{active: navSwitch === 'location'}"><span>SORT<br>BY<br>LOCATION</span></li>
      <li v-on:click="nav('category')" :class="{active: navSwitch === 'category'}"><span>SORT<br>BY<br>CATEGORY</span></li>
    </ul>

    <div class='text'>  
      <p>ABOUT TETATET</p>
      <p v-html="tetatet[2]" class='footerText footerText_letterspacing'></p> 
      
      <span class='footerLink'>
        <a href='https://soundcloud.com/fanfarefanfarefanfare' target="_blank">SOUNDCLOUD</a>
        <a href='mailto:fanfarefanfare@fanfarefanfare.nl'>CONTACT</a>
      </span>
    </div>
  </div> 
</template>

<script>
import Lamp from './library/lamp.vue'
import Aplayer from 'vue-aplayer'
import _ from 'underscore'

export default {
  name: 'Tetatet',
  components: {
      Aplayer,
      Lamp
  },
  data () {
    return { 
      navSwitch: 'issue',
    }
  },
  computed: {
    apidata () {
      return this.$store.state.apidata
    },
    issues () {
      return this.apidata['1-issues']
    },
    tetatet () {
      return _.values(this.apidata['2-tetatet'])
    },
    episodes () {
      const sort = _.sortBy(this.tetatet[6], function(val) { return val.sortLetter })
      return sort
    },
    categories () {
      const sort = _.sortBy(this.tetatet[5], function(val) {
          return val;
      })
      return sort
    },
    locations () {
      const sort = _.sortBy(this.tetatet[4], function(val) {
          return val;
      })
      return sort
    }
  },
  methods: {
      nav: function (val) {
        this.navSwitch = val
        window.scroll(0,0)
      }, 
      categoryCheck: function (param, val) {
        const arr = _.pluck(this.episodes, param)

        if(_.contains(arr , val)) {
          return true
        } 
      }
  },      
  mounted: function () {
    this.$store.state.classBody = 'tetatet'
    this.$store.state.compass = false
  }, 
  // beforeRouteEnter (to, from, next) {
  //   window.scroll(0,0)
  //   next()
  // },
  beforeRouteLeave (to, from, next) {
    this.$store.state.previousRoute = 'tetatet'
    const time = Math.floor(Math.random() * 200) + 10  
    this.$store.state.compass = true 
    setTimeout(function(){ next() }, time)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
    vm.$store.state.classBody = 'tetatet'
    })
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../styles/global.less";
    .white {
      color: @white
    }

    .player {
      margin: @mp-b 32px;
      div, span {
        background: white;
        font-family: 'scarlaregular';
        .fs-m !important;
        letter-spacing: 0.5px;
        color: @black !important;
      }
    }

    .conversations li {
      .player:first-of-type {
        margin-top: 0px;
      }
      &_title {

      }
    }

    .sort {
      width: 428px;
      margin: @mp-c auto -@mp-a auto;
      user-select: none;
      text-align: center;
      color: @blackMid;
      li {
        position: relative;
        display: inline-block;

        width: 122px;
        height: 122px;

        background: @white;
        border-radius: 50%;

        margin: 0 @mp-a/2;
        cursor: pointer;
        vertical-align: top;

        span {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          text-align: center;
          letter-spacing: 0.5px;
          .fs-l;

          user-select: none;
        }
      }

      li:not(.active):hover {
        background: @blackLight;
      }

      .active {
        background: @black;
        color: @white;
      }
    }

    .aplayer {
      border-radius: 4px !important;
      // box-shadow: -15 2px 6px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -4px rgba(0, 0, 0, 0.2), 0 1px 5px 10px rgba(0, 0, 0, 0.5) !important;
      box-shadow: -5px 2px 40px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 10px rgba(0, 0, 0, 0.3), 0 10px 20px 20px rgba(0, 0, 0, 0.2), -1px 0px 4px  rgba(0, 0, 0, 0.2) !important;
    }

    .aplayer-info {
      padding: 14px 7px 0 0px !important;
    }

    .aplayer-pic .aplayer-pause {
      width: 26px !important;
      height: 26px !important;
      border: 2px solid #fff !important;
      bottom: 50% !important;
      right: 50% !important;
      margin: 0 -15px -15px 0 !important;
    }

    .aplayer-pic .aplayer-pause > body{
      background: red !important;
    }

    .aplayer-pic .aplayer-pause .aplayer-icon-pause {
      position: absolute !important;
      top: 3px !important;
      left: 3px !important;;
      height: 20px !important;
      width: 20px !important;
    }

    .aplayer-icon-mode {
      display: none !important;
    }

    .aplayer-controller .aplayer-time .aplayer-icon {
      margin-bottom: 2px;
    }  

    .aplayer-controller .aplayer-time .aplayer-icon .aplayer-fill, .aplayer-pic .aplayer-button .aplayer-fill {
      fill: @black !important;
    }

    .aplayer-played {
      background: @black !important;
    }

    .aplayer-thumb {
      border: 1px solid @black !important;
      background-color: @black !important;
    }

    .aplayer-volume-bar-wrap {
      display: none !important;
    }

    .aplayer-controller .aplayer-time {
      position: absolute !important;
      top: -32px !important;
    }

    @media screen and (max-width: @breakpoint1) {
      .sort { 
        width: 100%;
        margin-bottom: @mp-c;
        li {
          width: 90px;
          height: 90px; 
          margin: 0 @mp-a/4;
          span {
            .fs-s;
          }
        }
      }  

      .player {
        margin: @mp-b @mp-a;
        div, span {
          .fs-s !important;
        } 
      }

      .aplayer-pic {
        width: 40px !important;
      }

      .aplayer-time {
        display: none !important;
      }

      .aplayer .aplayer-info {
        margin-left: 40px !important;
      }
    }

</style>




// WEBPACK FOOTER //
// src/components/Tetatet.vue